import React, { useState, useEffect } from 'react';
import ThemeToggle from './themetoggle';
import './style.css';
import { GithubIcon, LinkedinIcon } from '../../assets/iconSvg';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [pathname, setPathname] = useState('/');

  useEffect(() => {
    // Get current path
    setPathname(window.location.pathname);
    
    // Handle scroll events for navbar styling
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white/90 dark:bg-[#1E293B]/90 shadow-md backdrop-blur-sm' : 'bg-transparent'}`}>
      <nav className="container mx-auto px-4 py-3 flex items-center justify-between">
        {/* Left - Label (changes with dark mode) */}
        <div className="flex-none">
                <ThemeToggle />

        </div>

        {/* Center - Navigation Links (Desktop only) */}
        <div className="hidden md:flex items-center justify-center flex-1">
          <div className="flex space-x-8">
                <a
                  href="/"
              className={`nav-link text-gray-800 dark:text-gray-200 hover:text-[#0071c2] dark:hover:text-[#2196f3] transition-colors ${pathname === '/' ? 'font-semibold text-[#0071c2] dark:text-[#2196f3]' : ''}`}
                >
                  Home
                </a>

            {/* Projects Dropdown */}
            <div className="relative group">
  <button
                className={`nav-link flex items-center text-gray-800 dark:text-gray-200 hover:text-[#0071c2] dark:hover:text-[#2196f3] transition-colors ${pathname.includes('/projects') ? 'font-semibold text-[#0071c2] dark:text-[#2196f3]' : ''}`}
  >
    Projects
    <svg
                  className="w-4 h-4 ml-1 group-hover:rotate-180 transition-transform duration-200"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  </button>
              
              {/* Dropdown Menu */}
              <div className="absolute left-0 mt-2 w-48 bg-white dark:bg-[#1E293B] rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 transform group-hover:translate-y-0 translate-y-2 z-50">
        <a
          href="/projects/checkey"
                  className="block px-4 py-2 text-gray-800 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-t-lg"
        >
          Checkey
        </a>
        <a
          href="/projects/parque-invierno"
                  className="block px-4 py-2 text-gray-800 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
        >
          Parque Invierno
        </a>
        <a
          href="/projects/turistai"
                  className="block px-4 py-2 text-gray-800 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
        >
          Turist AI
        </a>
        <a
          href="/projects"
                  className="block px-4 py-2 text-gray-800 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-b-lg"
        >
                  All Projects
        </a>
              </div>
  </div>
            
            {/* Contact Link */}
                <a
                  href="/contact"
              className={`nav-link text-gray-800 dark:text-gray-200 hover:text-[#0071c2] dark:hover:text-[#2196f3] transition-colors ${pathname === '/contact' ? 'font-semibold text-[#0071c2] dark:text-[#2196f3]' : ''}`}
                >
                  Contact
                </a>
          </div>
        </div>

        {/* Right - Social Icons */}
        <div className="flex items-center space-x-4">
          <div className="hidden md:flex items-center justify-center space-x-6">
            <a 
              href="https://www.linkedin.com/in/capone-leonardo/" 
              target="_blank" 
              rel="noreferrer"
              className="flex items-center justify-center text-gray-600 hover:text-[#0A66C2] dark:text-gray-400 dark:hover:text-[#0A66C2] transition-colors"
            >
              <span className="w-6 h-6 flex items-center justify-center text-[#0A66C2]">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </span>
            </a>
            <a 
              href="https://github.com/Esquiafo/" 
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-center text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white transition-colors"
            >
              <span className="w-6 h-6 flex items-center justify-center text-gray-700 dark:text-gray-300 hover:text-black dark:hover:text-white transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
              </span>
            </a>
          </div>
          
          {/* Mobile Menu Toggle */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-gray-800 dark:text-gray-200 focus:outline-none"
          >
            {isOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
          </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`md:hidden bg-white dark:bg-[#1E293B] overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-screen opacity-100 pb-4' : 'max-h-0 opacity-0'}`}>
        <div className="container mx-auto px-4 py-2 space-y-3">
          <a
            href="/"
            className={`block py-2 text-gray-800 dark:text-gray-200 ${pathname === '/' ? 'font-semibold text-[#0071c2] dark:text-[#2196f3]' : ''}`}
            onClick={() => setIsOpen(false)}
          >
            Home
          </a>
          
          {/* Contact Link */}
          <a
            href="/contact"
            className={`block py-2 text-gray-800 dark:text-gray-200 ${pathname === '/contact' ? 'font-semibold text-[#0071c2] dark:text-[#2196f3]' : ''}`}
            onClick={() => setIsOpen(false)}
          >
            Contact
          </a>
          
          {/* Projects Section */}
          <div className="py-2">
            <p className="font-medium text-gray-800 dark:text-gray-200 mb-2">Projects</p>
            <div className="pl-4 space-y-2">
              <a
                href="/projects/checkey"
                className="block text-gray-800 dark:text-gray-200"
                onClick={() => setIsOpen(false)}
              >
                Checkey
              </a>
              <a
                href="/projects/parque-invierno"
                className="block text-gray-800 dark:text-gray-200"
                onClick={() => setIsOpen(false)}
              >
                Parque Invierno
              </a>
              <a
                href="/projects/turistai"
                className="block text-gray-800 dark:text-gray-200"
                onClick={() => setIsOpen(false)}
              >
                Turist AI
              </a>
              <a
                href="/projects"
                className="block text-gray-800 dark:text-gray-200"
                onClick={() => setIsOpen(false)}
              >
                All Projects
              </a>
            </div>
          </div>
          
          {/* Social Icons */}
          <div className="flex items-center justify-start space-x-6 pt-2">
            <a 
              href="https://www.linkedin.com/in/capone-leonardo/" 
              target="_blank" 
              rel="noreferrer"
              className="flex items-center justify-center text-gray-600 hover:text-[#0A66C2] dark:text-gray-400 dark:hover:text-[#0A66C2]"
            >
              <span className="w-6 h-6 flex items-center justify-center text-[#0A66C2]">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </span>
            </a>
            <a 
              href="https://github.com/Esquiafo/" 
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-center text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
            >
              <span className="w-6 h-6 flex items-center justify-center text-gray-700 dark:text-gray-300 hover:text-black dark:hover:text-white transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
